export default __webpack_public_path__ + "static/media/clocksvg.4d0ce18d.svg";